namespace Matrix.Workflow {
    export interface WorkflowForm {
        WorkflowCode: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        IsEnabled: Serenity.BooleanEditor;
        ReadPermissions: Serenity.StringEditor;
        WritePermissions: Serenity.StringEditor;
        ArchivePolicy: Serenity.StringEditor;
        Properties: Serenity.StringEditor;
        Class1Name: Serenity.StringEditor;
        Class1: Serenity.StringEditor;
        Class2Name: Serenity.StringEditor;
        Class2: Serenity.StringEditor;
        Class3Name: Serenity.StringEditor;
        Class3: Serenity.StringEditor;
        Class4Name: Serenity.StringEditor;
        Class4: Serenity.StringEditor;
        Class5Name: Serenity.StringEditor;
        Class5: Serenity.StringEditor;
        Key1Name: Serenity.StringEditor;
        Key1: Serenity.StringEditor;
        Key2Name: Serenity.StringEditor;
        Key2: Serenity.StringEditor;
        Key3Name: Serenity.StringEditor;
        Key3: Serenity.StringEditor;
        Key4Name: Serenity.StringEditor;
        Key4: Serenity.StringEditor;
        Key5Name: Serenity.StringEditor;
        Key5: Serenity.StringEditor;
        C1Name: Serenity.StringEditor;
        C1: Serenity.StringEditor;
        C2Name: Serenity.StringEditor;
        C2: Serenity.StringEditor;
        C3Name: Serenity.StringEditor;
        C3: Serenity.StringEditor;
        C4Name: Serenity.StringEditor;
        C4: Serenity.StringEditor;
        C5Name: Serenity.StringEditor;
        C5: Serenity.StringEditor;
        C6Name: Serenity.StringEditor;
        C6: Serenity.StringEditor;
        C7Name: Serenity.StringEditor;
        C7: Serenity.StringEditor;
        C8Name: Serenity.StringEditor;
        C8: Serenity.StringEditor;
        C9Name: Serenity.StringEditor;
        C9: Serenity.StringEditor;
        C10Name: Serenity.StringEditor;
        C10: Serenity.StringEditor;
        B1Name: Serenity.StringEditor;
        B1: Serenity.BooleanEditor;
        B2Name: Serenity.StringEditor;
        B2: Serenity.BooleanEditor;
        B3Name: Serenity.StringEditor;
        B3: Serenity.BooleanEditor;
        B4Name: Serenity.StringEditor;
        B4: Serenity.BooleanEditor;
        B5Name: Serenity.StringEditor;
        B5: Serenity.BooleanEditor;
        B6Name: Serenity.StringEditor;
        B6: Serenity.BooleanEditor;
        B7Name: Serenity.StringEditor;
        B7: Serenity.BooleanEditor;
        B8Name: Serenity.StringEditor;
        B8: Serenity.BooleanEditor;
        B9Name: Serenity.StringEditor;
        B9: Serenity.BooleanEditor;
        B10Name: Serenity.StringEditor;
        B10: Serenity.BooleanEditor;
        N1Name: Serenity.StringEditor;
        N1: Serenity.IntegerEditor;
        N2Name: Serenity.StringEditor;
        N2: Serenity.IntegerEditor;
        N3Name: Serenity.StringEditor;
        N3: Serenity.IntegerEditor;
        N4Name: Serenity.StringEditor;
        N4: Serenity.IntegerEditor;
        N5Name: Serenity.StringEditor;
        N5: Serenity.IntegerEditor;
        N6Name: Serenity.StringEditor;
        N6: Serenity.IntegerEditor;
        N7Name: Serenity.StringEditor;
        N7: Serenity.IntegerEditor;
        N8Name: Serenity.StringEditor;
        N8: Serenity.IntegerEditor;
        N9Name: Serenity.StringEditor;
        N9: Serenity.IntegerEditor;
        N10Name: Serenity.StringEditor;
        N10: Serenity.IntegerEditor;
        F1Name: Serenity.StringEditor;
        F1: Serenity.DecimalEditor;
        F2Name: Serenity.StringEditor;
        F2: Serenity.DecimalEditor;
        F3Name: Serenity.StringEditor;
        F3: Serenity.DecimalEditor;
        F4Name: Serenity.StringEditor;
        F4: Serenity.DecimalEditor;
        F5Name: Serenity.StringEditor;
        F5: Serenity.DecimalEditor;
        F6Name: Serenity.StringEditor;
        F6: Serenity.DecimalEditor;
        F7Name: Serenity.StringEditor;
        F7: Serenity.DecimalEditor;
        F8Name: Serenity.StringEditor;
        F8: Serenity.DecimalEditor;
        F9Name: Serenity.StringEditor;
        F9: Serenity.DecimalEditor;
        F10Name: Serenity.StringEditor;
        F10: Serenity.DecimalEditor;
        D1Name: Serenity.StringEditor;
        D1: Serenity.DateTimeEditor;
        D2Name: Serenity.StringEditor;
        D2: Serenity.DateTimeEditor;
        D3Name: Serenity.StringEditor;
        D3: Serenity.DateTimeEditor;
        D4Name: Serenity.StringEditor;
        D4: Serenity.DateTimeEditor;
        D5Name: Serenity.StringEditor;
        D5: Serenity.DateTimeEditor;
        Txt1Name: Serenity.StringEditor;
        Txt1: Serenity.TextAreaEditor;
        Txt2Name: Serenity.StringEditor;
        Txt2: Serenity.TextAreaEditor;
        Txt3Name: Serenity.StringEditor;
        Txt3: Serenity.TextAreaEditor;
        Txt4Name: Serenity.StringEditor;
        Txt4: Serenity.TextAreaEditor;
        Txt5Name: Serenity.StringEditor;
        Txt5: Serenity.TextAreaEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class WorkflowForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.Workflow';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WorkflowForm.init)  {
                WorkflowForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.DateTimeEditor;
                var w5 = s.TextAreaEditor;
                var w6 = StaticTextBlock;
                var w7 = ReadOnlyDateTime;

                Q.initFormType(WorkflowForm, [
                    'WorkflowCode', w0,
                    'Description', w0,
                    'IsEnabled', w1,
                    'ReadPermissions', w0,
                    'WritePermissions', w0,
                    'ArchivePolicy', w0,
                    'Properties', w0,
                    'Class1Name', w0,
                    'Class1', w0,
                    'Class2Name', w0,
                    'Class2', w0,
                    'Class3Name', w0,
                    'Class3', w0,
                    'Class4Name', w0,
                    'Class4', w0,
                    'Class5Name', w0,
                    'Class5', w0,
                    'Key1Name', w0,
                    'Key1', w0,
                    'Key2Name', w0,
                    'Key2', w0,
                    'Key3Name', w0,
                    'Key3', w0,
                    'Key4Name', w0,
                    'Key4', w0,
                    'Key5Name', w0,
                    'Key5', w0,
                    'C1Name', w0,
                    'C1', w0,
                    'C2Name', w0,
                    'C2', w0,
                    'C3Name', w0,
                    'C3', w0,
                    'C4Name', w0,
                    'C4', w0,
                    'C5Name', w0,
                    'C5', w0,
                    'C6Name', w0,
                    'C6', w0,
                    'C7Name', w0,
                    'C7', w0,
                    'C8Name', w0,
                    'C8', w0,
                    'C9Name', w0,
                    'C9', w0,
                    'C10Name', w0,
                    'C10', w0,
                    'B1Name', w0,
                    'B1', w1,
                    'B2Name', w0,
                    'B2', w1,
                    'B3Name', w0,
                    'B3', w1,
                    'B4Name', w0,
                    'B4', w1,
                    'B5Name', w0,
                    'B5', w1,
                    'B6Name', w0,
                    'B6', w1,
                    'B7Name', w0,
                    'B7', w1,
                    'B8Name', w0,
                    'B8', w1,
                    'B9Name', w0,
                    'B9', w1,
                    'B10Name', w0,
                    'B10', w1,
                    'N1Name', w0,
                    'N1', w2,
                    'N2Name', w0,
                    'N2', w2,
                    'N3Name', w0,
                    'N3', w2,
                    'N4Name', w0,
                    'N4', w2,
                    'N5Name', w0,
                    'N5', w2,
                    'N6Name', w0,
                    'N6', w2,
                    'N7Name', w0,
                    'N7', w2,
                    'N8Name', w0,
                    'N8', w2,
                    'N9Name', w0,
                    'N9', w2,
                    'N10Name', w0,
                    'N10', w2,
                    'F1Name', w0,
                    'F1', w3,
                    'F2Name', w0,
                    'F2', w3,
                    'F3Name', w0,
                    'F3', w3,
                    'F4Name', w0,
                    'F4', w3,
                    'F5Name', w0,
                    'F5', w3,
                    'F6Name', w0,
                    'F6', w3,
                    'F7Name', w0,
                    'F7', w3,
                    'F8Name', w0,
                    'F8', w3,
                    'F9Name', w0,
                    'F9', w3,
                    'F10Name', w0,
                    'F10', w3,
                    'D1Name', w0,
                    'D1', w4,
                    'D2Name', w0,
                    'D2', w4,
                    'D3Name', w0,
                    'D3', w4,
                    'D4Name', w0,
                    'D4', w4,
                    'D5Name', w0,
                    'D5', w4,
                    'Txt1Name', w0,
                    'Txt1', w5,
                    'Txt2Name', w0,
                    'Txt2', w5,
                    'Txt3Name', w0,
                    'Txt3', w5,
                    'Txt4Name', w0,
                    'Txt4', w5,
                    'Txt5Name', w0,
                    'Txt5', w5,
                    'CreatedBy', w6,
                    'CreatedWhen', w7,
                    'UpdatedBy', w6,
                    'UpdatedWhen', w7,
                    'Version', w6
                ]);
            }
        }
    }
}
